import React from 'react';
import { makeStyles, Grid, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: 12,
        padding: '0 5px'
    },
    typeDiv: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    otRequestContainer: {
        width: '2.5rem', 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    otRequestDiv: {
        color: '#fff',
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '1.75rem', 
        height: '1.7rem', 
        background: '#5A72B7', 
        borderRadius: '50%',
        fontSize: '10px',
    },
    otText: {
        position: 'absolute',
    }
}));

const annualLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#ffa500' },
};
const sickLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#00b7eb' },
};
const compensationLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#cccc00' },
};
const maternityLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#b8860b' },
};
const paternityLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#0000ff' },
};
const marriageLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#800080' },
};
const birthdayLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#ff00ff' },
};
const compassionateLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#ccccff' },
};
const examinationLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#40e0d0' },
};
const juryLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#ff7f50' },
};
const noPayLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#808000' },
};
const otherLeave = {
    style: { width: '2.5rem', height: '1rem', background: '#FAEBD7' },
};
const compLeaveRequest = {
    style: { width: '2rem', height: '2rem', background: '#4DE67F', borderRadius: '50%' },
};
const pending = {
    border: 1,
    style: { width: '2.5rem', height: '1rem', background: 'repeating-linear-gradient( 45deg, #808080, #808080 4px, #FFF 4px, #FFF 10px )' },
};
const rejected = {
    style: { width: '2.5rem', height: '1rem', background: '#D3D3D3' },
};
const holiday = {
    style: { width: '2.5rem', height: '1rem', background: '#FEE11D' },
};

export default function Guideline({ page }) {
    const classes = useStyles();
    const [showHoliday, setShowHoliday] = React.useState();
    const [showOTRequest, setShowOTRequest] = React.useState(false);
    React.useEffect(() => {
        if (page === 'Calendar') {
            setShowHoliday(true);
            setShowOTRequest(false);
        } else {
            setShowHoliday(false);
            setShowOTRequest(true);
        }
    }, [page]);
    return (
        <Grid container spacing={0}>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...annualLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.Annual Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...sickLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.Sick Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...compensationLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.Compensation Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...maternityLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.Maternity Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...paternityLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.Paternity Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...marriageLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.Marriage Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...birthdayLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.Birthday Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...compassionateLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.Compassionate Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...examinationLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.Examination Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...juryLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.Jury Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...noPayLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.No Pay Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...otherLeave} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.Other Leave"
                        />
                    </Typography>
                </div>
            </Grid>
            {showOTRequest && (
                <Grid item lg={2} md={3} sm={6} xs={12}>
                    <div className={classes.typeDiv}>
                        <div className={classes.otRequestContainer}>
                            <div className={classes.otRequestDiv}>OT</div>
                        </div>
                        <Typography className={classes.title}>
                            <FormattedMessage
                                id="guideline.OT Request"
                            />
                        </Typography>
                    </div>
                </Grid>
            )}
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...pending} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.submitted_pending"
                        />
                    </Typography>
                </div>
            </Grid>
            <Grid item lg={2} md={3} sm={6} xs={12}>
                <div className={classes.typeDiv}>
                    <Box {...rejected} />
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="guideline.rejected"
                        />
                        {page !== 'Calendar' && (
                            <span>
                                / <FormattedMessage
                                    id="guideline.cancelled"
                                />
                            </span>
                        )}
                    </Typography>
                </div>
            </Grid>
            {showHoliday &&
                <Grid item lg={2} md={3} sm={6} xs={12}>
                    <div className={classes.typeDiv}>
                        <Box {...holiday} />
                        <Typography className={classes.title}>
                            <FormattedMessage
                                id="guideline.holiday"
                            />
                        </Typography>
                    </div>
                </Grid>
            }
        </Grid>
    );
}